module.exports = __webpack_public_path__ + "static/media/ReportsActive.3b722320.svg";